import React, { FC, useEffect } from 'react'
import size from 'lodash/size'
import { IUploadedImageAsset } from '@api'
import ImagesList from './components/ImagesList/ImagesList'
import UploadImages from './components/UploadImages/UploadImages'
import useUploadSpaceImages from './hooks/useUploadSpaceImages'
import css from './uploadSpaceImages.module.scss'

type UploadSpaceImagesProps = {
  spaceId: string
  isAssetsLoading: boolean
  assets: IUploadedImageAsset[]
  updateDefaultImage: boolean
  setUpdateDefaultImage: (value: boolean) => void
}

const UploadSpaceImages: FC<React.PropsWithChildren<UploadSpaceImagesProps>> = ({
  spaceId,
  assets,
  isAssetsLoading,
  updateDefaultImage,
  setUpdateDefaultImage,
}) => {
  const {
    uploadImagesHandler,
    uploadedImages,
    deleteImagesHandler,
    setImagesAsDefaultHandler,
    progress,
  } = useUploadSpaceImages(spaceId, assets, updateDefaultImage, setUpdateDefaultImage)

  return (
    <div className={css.wrapper}>
      <h2 className={css.title}>Upload Images of Space</h2>
      <UploadImages
        progress={progress}
        spaceId={spaceId}
        isAssetsLoading={isAssetsLoading}
        uploadedImages={uploadedImages}
        onDrop={uploadImagesHandler}
      />
      <ImagesList
        isAssetsLoading={isAssetsLoading}
        assets={uploadedImages}
        onDeleteImage={deleteImagesHandler}
        onClickDefaultImage={setImagesAsDefaultHandler}
      />
    </div>
  )
}

export default UploadSpaceImages
